export enum SORTIE_EXPORT_TYPE {
	RECOLTE_THEORIQUE_SEMAINE = 'RECOLTE_THEORIQUE_SEMAINE',
	BON_LIVRAISON = 'BON_LIVRAISON',
	TABLEAU_SORTIE = 'TABLEAU_SORTIE'
}

export enum SORTIE_EXPORT_ORIGIN {
	PLANIFICATION_TACHES = 'PLANIFICATION_TACHES',
	SORTIE = 'SORTIE'
}